import { render } from "./Icons.vue?vue&type=template&id=9e10d088"
const script = {}

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__